<script lang="ts">
  import CTooltip from '$shared/atoms/CTooltip/CTooltip.svelte';
  import { TooltipTextAlignment } from '$shared/atoms/CTooltip/CTooltipProp';
  import Icon from '$shared/atoms/Icon/Icon.svelte';
  import Label from '$provider/constants/Label';

  interface Props {
    value?: string;
    onclick?: (e: MouseEvent) => void;
  }

  let { value = '', onclick }: Props = $props();

  let htmlString = $derived((value && `Reset value from CAQH: </br> <b>${value}</b>`) || '');
</script>

<button
  class="reset-icon-content"
  onclick={(e) => { e.stopPropagation(); onclick?.(e); }}
>
  <CTooltip hide={!value} label={htmlString} textAlign={TooltipTextAlignment.Center}>
    <div class="reset-icon">
      <Icon value="icon-rotate-cw" size={'14px'} fontSize={'14px'} />
    </div>
  </CTooltip>
  <div class="reset-label">{Label.Reset}</div>
</button>

<style>
  .reset-icon-content {
    display: flex;
    align-items: center;
    margin-left: 12px;
  }
  .reset-icon {
    display: flex;
    align-items: center;
    margin-right: 6px;
    margin-top: 2px;
  }
</style>
